$ = jQuery = require('jquery');

// Import bootstrap libraries
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'font-awesome/css/font-awesome.min.css';
import 'nouislider/distribute/nouislider.min.css';
import 'jquery-zoom/jquery.zoom.js';

/* Filters
--------------------- */

import './filters/pagination';
import './filters/filters';
import './filters/length';
import './filters/mini_pagination';

/* Styles
--------------------- */

import './styles/main.scss';

/* Scripts
--------------------- */

import './scripts/rating';
import './scripts/drag&drop';
import './scripts/toast';
import './scripts/confirm';
import './scripts/bisiesto';

import { router } from './routes/routes';
import store from './store/store';
import { sync } from 'vuex-router-sync';

sync(store, router);

/* User & Password
--------------------- */

// email: leo.02.alex@gmail.com
// password: 123456789

// email: asdasdasd@sad.com
// password: 123456789


// WEBPACK FOOTER //
// ./src/main.js